import { events as cssAnimationEvents } from '../actions/cssAnimations'
import { events as screenEvents } from '../actions/screen'

export default (previousState, action) => {
    if (!previousState) previousState = {
        className: screenEvents.CSS_ANIMATIONS_PRE_CLASS //default
    };
// console.log(action.type)
    switch (action.type) {
        // case screenEvents.FORCE_UPDATE:
        // case screenEvents.SET_ALL_SCREENS_JSON:
        case cssAnimationEvents.CSS_ANIMATION_RESET:
            previousState.className = cssAnimationEvents.CSS_ANIMATIONS_PRE_CLASS;
            break;
        case cssAnimationEvents.CSS_ANIMATIONS_ANIMATE:
            previousState.className = cssAnimationEvents.CSS_ANIMATIONS_CLASS;
            break;
        default: break;
    }

    return { ...previousState }
}